export function parseStoredJson<T = object>(value: string | null, defaultValue?: T): T | undefined {
  try {
    return value ? (JSON.parse(value) as T) : defaultValue;
  } catch (e) {
    return defaultValue;
  }
}
